import styled from 'styled-components/macro';
import { colourNeutral09, colourNeutral10, colourNeutral11 } from '../styling/colours';
import { fontSize01, fontSize02 } from '../styling/fonts';
import { spacing03, spacing04 } from '../styling/spacing';

const tableBorderWidth = '1px';

export const Table = styled.table`
  border-spacing: 0;
  border: ${tableBorderWidth} solid ${colourNeutral09};
  background-color: ${colourNeutral10};
  width: calc(100% - ${tableBorderWidth} - ${tableBorderWidth});
  margin: 0;
`;

export const THead = styled.thead`
  height: 100%;
  align-items: center;
`;

export const Tr = styled.tr`
  &:nth-child(odd) {
    background-color: ${colourNeutral11};
  }

  &:nth-child(even) {
    background-color: ${colourNeutral10};
  }
`;

export const Th = styled.th`
  padding: ${spacing03} ${spacing04};
  height: 100%;
  text-transform: uppercase;
  text-align: left;
  font-size: ${fontSize01};
  letter-spacing: 0.5px;
  background-color: ${colourNeutral10};
`;

export const RightAlignedTh = styled(Th)`
  text-align: right;
`;

export const TBody = styled.tbody``;

export const ClickableTr = styled(Tr)`
  transition: all 0.15s ease;

  &:hover {
    cursor: pointer;
    background-color: ${colourNeutral09};
  }
`;

export const Td = styled.td`
  padding: ${spacing04};
  font-size: ${fontSize02};
  line-height: 1.7;
`;

export const RightAlignedTd = styled(Td)`
  text-align: right;
`;
